<template>
  <vs-popup
    :title="'Grupo de Veículos'"
    :active.sync="modalGrupos"
    @close="modalGrupos = false"
  >
    <vs-list>
      <vs-list-item
        v-for="(grupoTipo, index) in gruposEncontrados"
        :key="index"
        :title="grupoTipo.label"
        :subtitle="
          grupoTipo.descricaoProdutos ? grupoTipo.descricaoProdutos : ''
        "
      >
        <vs-radio
          color="success"
          v-model="grupoEncontradoSelecionado"
          :vs-value="grupoTipo"
        ></vs-radio>
      </vs-list-item>
    </vs-list>
    <vs-row>
      <vs-col vs-type="flex" vs-justify="flex-end">
        <vs-button
          @click.stop.prevent="selecionaGrupoEncontrado()"
          color="success"
          class="mr-3 mt-2 mb-2"
          >Escolher</vs-button
        >
      </vs-col>
    </vs-row>
  </vs-popup>
</template>
<script>
import services from '../../../../../services';
import functions from '../../../../../utils/functions';
import produtoService from '../../../../../services/produtos/index';

export default {
  name: 'ModalEditVeiculo',

  props: {
    veiculoAtual: {
      type: Object,
      default: () => {},
    },
    veiculoIndex: Number,
  },

  data() {
    return {
      modalGrupos: false,
      gruposEncontrados: [],
      form: null,
      naoSalvarModeloVeiculo: false,
      veiculoSemGrupo: false,
    };
  },
  methods: {
    openModal() {
      this.form = JSON.parse(JSON.stringify(this.veiculoAtual));
      this.selecionaGruposFipe();
      this.modalGrupos = true;
    },
    closeModal() {
      this.form = null;
      this.modalGrupos = false;
    },
    verificaEmpresa() {
      return functions.verificaEmpresaBemProtege(this.form.idEmpresa);
    },
    async selecionaGruposFipe() {
      if (this.form.veiculo.anoFabricacao) {
        this.naoSalvarModeloVeiculo = true;
      }

      if (this.form.grupos.length === 0) {
        this.form.veiculo.anoFabricacao = null;
        this.form.veiculo.anoGeral = null;
        this.form.veiculo.anoModelo = null;
        this.form.veiculo.modelo = null;
        this.naoSalvarModeloVeiculo = true;
        this.veiculoSemGrupo = true;
        return;
      }

      if (this.form.grupos.length === 1) {
        this.form.veiculo.idGrupo = this.form.grupos[0].id;
        this.form.veiculo.labelGrupo = this.form.grupos[0].label;
        this.gruposEncontrados = [this.form.grupos[0]];
        this.grupoEncontradoSelecionado = this.form.grupos[0];
        this.naoSalvarModeloVeiculo = false;
        return;
      }

      this.gruposEncontrados = this.form.grupos;
      this.grupoEncontradoSelecionado = this.form.grupos.find(
        (grupo) => grupo.id === this.form.idGrupo.id,
      );
      this.naoSalvarModeloVeiculo = true;
      this.modalGrupos = true;
    },

    async buscarProdutosVeiculo() {
      try {
        this.$vs.loading();
        const { data: produtosVeiculoMultiplo } = await services.post(
          'CotacaoAberta',
          'BuscaProdutos',
          this.form,
        );

        this.foraTabela = false;
        this.buscouProdutos = true;
        if (produtosVeiculoMultiplo.length === 0) {
          this.notifyMsg('danger', 'Nenhum Produto Encontrado para essa faixa');
          return;
        }
        let prodsOk = true;
        const idTipoFipe = this.form.idGrupo.idTipoFipe;

        if (idTipoFipe !== 3 || this.form.somenteAgregado) {
          this.form.produtos = produtosVeiculoMultiplo;
        }

        if (idTipoFipe === 3 && !this.form.somenteAgregado) {
          this.form.produtos = produtosVeiculoMultiplo.produtosVeiculo;

          if (produtosVeiculoMultiplo.produtosAgregados.length > 0) {
            let _agregados = produtosVeiculoMultiplo.produtosAgregados.reduce(
              (acc, item) => {
                let _produtosObrigatorios = [];
                let _produtosNaoObrigatorios = [];
                let _produtosSelecionados = [];
                item.produtos.forEach((produto) => {
                  produto.valorFinal = produto.valor;
                  produto.descontoConcedido = 0;
                  produto.id = produto.id_produto;
                  if (produto.obrigatorio) {
                    _produtosObrigatorios.push(produto);
                    _produtosSelecionados.push(produto);
                  } else {
                    _produtosNaoObrigatorios.push(produto);
                  }
                });
                const agregado = {
                  ...item,
                  produtosObrigatorios: _produtosObrigatorios,
                  produtosNaoObrigatorios: _produtosNaoObrigatorios,
                  produtosSelecionados: _produtosSelecionados,
                };
                acc.push(agregado);
                return acc;
              },
              [],
            );
            this.form.agregados = _agregados;
          }
        }

        this.form.produtos.forEach((produto, index) => {
          if (produto.acrescimoMensalidade === 'null') {
            produto.acrescimoMensalidade = null;
          }

          if (
            produto.acrescimoMensalidade &&
            this.form.idTipoEstacionamento === 2
          ) {
            const produtoComAcrescimo =
              produtoService.aplicaAcrescimoMensalidade(
                produto,
                this.form.estado,
              );

            this.form.produtos[index] = produtoComAcrescimo;
          }

          if (!produto.isComplementar) {
            produto.exibir = true;
          }

          if (produto.isComplementar) {
            produto.exibir = false;
          }
        });

        this.form.produtosObrigatorios = [];
        this.form.produtosNaoObrigatorios = [];
        this.form.produtosSelecionados = [];
        this.form.produtos.forEach((element) => {
          element.valorFinal = element.valor;
          element.descontoConcedido = 0;
          element.id = element.id_produto;
          if (element.obrigatorio) {
            this.form.produtosObrigatorios.push(element);
            this.form.produtosSelecionados.push(element);
          } else {
            this.form.produtosNaoObrigatorios.push(element);
          }
          if (element.valor === null) {
            prodsOk = false;
          }
        });

        this.form.produtosObrigatorios.sort(function (a, b) {
          return a.nomeProduto < b.nomeProduto
            ? -1
            : a.nomeProduto > b.nomeProduto
            ? 1
            : 0;
        });
        this.formInformacoes = this.form;
        this.form.produtosNaoObrigatorios.sort(function (a, b) {
          return a.nomeProduto < b.nomeProduto
            ? -1
            : a.nomeProduto > b.nomeProduto
            ? 1
            : 0;
        });
        if (!prodsOk) {
          this.form.produtos = [];
          this.foraTabela = true;
          this.notifyMsg('danger', 'Valores fora da Tabela');
        }
      } catch (e) {
        this.notifyMsg('danger', e);
      } finally {
        this.$vs.loading.close();
      }
    },

    notifyMsg(color, msg, timer = 2000) {
      return this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: msg,
        color: color,
        timer,
      });
    },

    async selecionaGrupoEncontrado() {
      this.form.idGrupo = {
        ...this.grupoEncontradoSelecionado,
      };
      this.buscarProdutosVeiculo();
      this.naoSalvarModeloVeiculo = false;
      this.$emit('update:veiculo', this.form, this.veiculoIndex);
      this.modalGrupos = false;
    },
  },
};
</script>
